import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { enhancedConnect } from "../../../../utils";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var _VideoPlayer = function _VideoPlayer(_ref) {
  var url = _ref.url,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 260 : _ref$height,
    _ref$allowAttributes = _ref.allowAttributes,
    allowAttributes = _ref$allowAttributes === void 0 ? 'encrypted-media; fullscreen; picture-in-picture;' : _ref$allowAttributes,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('video-player', className),
    style: {
      height: height
    },
    "data-t-id": "components-VideoPlayer"
  }, /*#__PURE__*/React.createElement("iframe", {
    allow: allowAttributes,
    allowFullScreen: true,
    className: cx('video'),
    frameBorder: "0",
    height: height,
    src: url,
    title: "video"
  }));
};
export var VideoPlayer = enhancedConnect({
  allowAttributes: PropTypes.string,
  url: PropTypes.string,
  height: PropTypes.number
})(_VideoPlayer);